export default "__VITE_ASSET__CFQHMiH3__"